import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import 'rxjs/add/operator/do';

import {TokenStorage} from './Utility/TokenStorage';
import {SessionTimeoutModal} from './modals/sessionTimeout.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoaderComponent} from '../loader/loader.component';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import { sha256 } from 'js-sha256';


const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class Interceptor implements HttpInterceptor {
  progressRef: any;
  count:any = 0;
  constructor(
    private token: TokenStorage,
    private router: Router,
    private modalService: NgbModal
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler):
            Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    let authReq = req;
    this.count=1;
    setTimeout(() => this.modalService.open(LoaderComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'loaderBackdrop',
      windowClass: this.count
    }), 0);


    //If token exists, clone request and additional keys for JWT authentication
    if (this.token.getToken() != null) {
      authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + this.token.getToken())});
    }

    if(req.url.indexOf('citizenportal') !== -1 || req.url.indexOf('GetCitizenClientInfo') !== -1 || req.url.indexOf('Aries/clientInfo') !== -1){
      let authHeader={personId:null,timeStamp:Date.now()};
      let key = sha256('PmIbwNHs2aKv16jBstjNd841pxdPl6gureFTCVQ').toString();
      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(authHeader), key);
      authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, encrypted.toString())});
    }
    return next.handle(authReq).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        //Do stuff with response if you want
        setTimeout(() => {
          console.log("Removed");
          $('ngb-modal-window.'+this.count+':visible').remove();
          $('ngb-modal-backdrop:visible').remove();
          $('h1').focus();
          $('a.active').focus();
          $('a.elasticSearch').focus();
          $('input.elasticSearch').focus();
          $('select.elasticSearch').focus();
          $('label.elasticSearch').focus();
          $('button.elasticSearch').focus();
        }, 0);
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        let modalRef;
        //console.log('Request URL :: ' + req.url + ' | Interceptor error :: ' + err.message);
        setTimeout(() => {
          $('ngb-modal-window:visible').remove();
          $('ngb-modal-backdrop:visible').remove();
          $('h1').focus();
          $('a.active').focus();
          $('input.elasticSearch').focus();
          $('select.elasticSearch').focus();
        }, 0);

        //If session expired and following conditions met, display Session Timeout modal
        if (err.status === 401 && err.error && err.error.message === '4002') {
          modalRef = this.modalService.open(SessionTimeoutModal, { centered: true, size: 'lg' });
        }
      }
    });
  }

  openDialog() {
    this.progressRef = this.modalService.open(LoaderComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'loaderBackdrop'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/request-inteceptor.ts